import React, { ReactElement } from "react";
import { IdwalGrade } from "../../IdwalGrades/IdwalGrade";
import { ReportDetailsProps } from "../../types/ReportDetailsProps";
import { Trans, useTranslation } from "react-i18next";
import "./ReportDetails.css";
import { DetailsItem } from "../../types/InspectionReportDetails";

const renderDetailsItem = (item: DetailsItem) => (
    <div key={item.key} className="col-12 sm:col-6 lg:col-3 pb-0">
        <small className="report-details-key">
            <Trans
                ns="common"
                i18nKey={`inspectionReport.reportDetails.${item.key}`}
            />
        </small>
        <p
            className="report-details-value"
            data-cy={`report-table-${item.selector}`}
        >
            {item.value}
        </p>
    </div>
);

export const ReportDetails = (props: ReportDetailsProps): ReactElement => {
    const { Grade, GradeImageUrl, ShipName, InspectionType, Details } =
        props.reportDetails;

    const { t } = useTranslation("common");

    return (
        <div>
            <div className="grid">
                <div className="col">
                    <h3
                        className="report-header-inspection-type"
                        data-cy="report-table-header-inspection-type"
                    >
                        {`${t("inspectionReport.reportDetails.reportType", {
                            inspectionType: InspectionType
                        })}`}
                    </h3>
                    <div className="report-divider" />
                    <h1
                        className="report-vessel-name"
                        data-cy="report-table-vessel-name"
                    >
                        {ShipName}
                    </h1>
                </div>
                <div className="col-fixed ml-auto">
                    {GradeImageUrl ? (
                        <img src={GradeImageUrl} />
                    ) : (
                        <IdwalGrade
                            grade={Grade}
                            size={"normal"}
                            width={240}
                            height={96}
                        />
                    )}
                </div>
            </div>
            <div className="grid pt-0">{Details.map(renderDetailsItem)}</div>
        </div>
    );
};
